<template>
  <div class="brandSet">
    <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
      <el-radio-button label="1">品牌配置</el-radio-button>
      <el-radio-button label="2">积木云助手</el-radio-button>
    </el-radio-group>
    <el-card v-show="tabPosition == 1" class="my_card" shadow="never">
      <div class="top">
        <p>
          <span class="s1">品牌设置</span
          ><span class="s2"
            >管理员可根自身企业的使用需求，配置自身品牌指示</span
          >
        </p>
        <el-button type="primary" round>保存</el-button>
      </div>
      <!-- 销售管理 -->
      <div class="sell">
        <div class="sell_title">
          <p class="sell_title_p1">
            <img src="../../assets/images/ticons/Frame.png" alt="" />
            <span class="c333" style="margin-left: 8px">销售管理</span>
          </p>
          <p class="sell_title_p2 c777" style="margin-top: 5px">
            管理员可根据自身企业的使用需求，配置自身品牌标示
          </p>
        </div>
        <el-form
          :label-position="labelPosition"
          label-width="80px"
          :model="formLabelAlign"
        >
          <el-form-item label="品牌名称:">
            <el-input
              v-model="formLabelAlign.name"
              placeholder="请输入品牌名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌图标:">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <p class="tips"><span>*</span>请按尺寸上传png/jpg格式且小于2M的图片</p>
      </div>
      <!-- bi -->
      <div class="bi">
        <div class="sell_title">
          <p class="sell_title_p1">
            <img src="../../assets/images/ticons/icon／20＊20.png" alt="" />
            <span class="c333" style="margin-left: 8px">驾驶舱标识</span>
          </p>
          <p class="sell_title_p2 c777" style="margin-top: 5px">
            管理员可根据自身企业的使用需求，配置bi驾驶舱的品牌标示
          </p>
        </div>
        <el-form
          :label-position="labelPosition"
          label-width="80px"
          :model="formLabelAlign"
        >
          <el-form-item label="品牌名称:">
            <el-input
              v-model="formLabelAlign.name2"
              placeholder="请输入品牌名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌图标:">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <p class="tips"><span>*</span>请按尺寸上传png/jpg格式且小于2M的图片</p>
      </div>
    </el-card>
    <jimuyun v-show="tabPosition == 2"></jimuyun>
  </div>
</template>

<script>
import jimuyun from "./components/jimuyun.vue";
export default {
  components: {
    jimuyun,
  },
  data() {
    return {
      // 控制顶部两个按钮切换
      tabPosition: "1",
      //表单
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        name2:'',
        region: "",
        type: "",
      },
      //上传组件
      imageUrl: "",
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG或者PNG  格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
  },
};
</script>

<style lang="less">
.brandSet {
  padding: 20px;
  img {
    width: 20px;
    height: 20px;
  }
  .el-radio-button:first-child .el-radio-button__inner {
    width: 106px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 18px 0 0 18px;
  }
  .el-radio-button:last-child .el-radio-button__inner {
    width: 106px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 0 18px 18px 0;
  }
  .my_card {
    height: 650px;
    padding: 0 50px 0 0;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .s1 {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #33393f;
      }
      .s2 {
        margin-left: 12px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
      }
      .el-button {
        font-size: 12px;
      }
      .el-button--mini,
      .el-button--mini.is-round {
        padding: 9px 15px;
      }
    }
    // 销售管理
    .sell,
    .bi {
      box-sizing: border-box;
      margin-left: 20px;
      margin-top: 20px;
      padding-left: 36px;
      padding-top: 17px;
      width: 100%;
      height: 270px;
      background: rgba(50, 126, 255, 0.06454873085021973);
      border-radius: 7px 7px 7px 7px;
      .sell_title_p1 {
        display: flex;
        align-items: center;
      }
      .tips {
        margin-left: 80px;
        margin-top: -17px;
        font-size: 10px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #aab2bb;
        span {
          color: #e02020;
        }
      }
      .el-form {
        margin-top: 30px;
      }
      .el-input .el-input__inner {
        width: 424px;
        border-radius: 15px;
      }
      .avatar-uploader {
        border: none;
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        background-color: #fff;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
      }
      .el-icon-plus:before {
        font-size: 14px;
        color: #d7d7d7;
      }
      .avatar {
        width: 80px;
        height: 80px;
        display: block;
      }
    }
  }
  //   公共样式
  .c333 {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #33393f;
  }
  .c777 {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
  }
}
</style>